module.exports = __webpack_public_path__ + "img/20_78.fafab9cb.png";